import React, { useEffect } from "react";

import Input from "../../../controls/Input";
import type { OverlayState } from "../../../../features/recipes/recipeTypes";
import { useForm } from "../../useForm";

const initialFValues = {
  quantity: "",
};

interface QuantityPopupItem {
  name?: string;
  quantity?: string | number;
  unit_of_measure?: { label?: string };
  unit_of_measure_label?: string | null;
}

interface AddBomToIngredientPopupProps {
  bomItem: QuantityPopupItem;
  confirmAction: (values: Record<string, any>, index?: number) => void;
  index?: number;
  isEdit?: boolean;
  setOpen: (state: OverlayState) => void;
}

export default function AddBomToIngredientPopup({
  bomItem,
  confirmAction,
  index,
  isEdit,
  setOpen,
}: AddBomToIngredientPopupProps) {
  const { values, setValues, errors, handleInputChange } = useForm(
    initialFValues,
    false,
  );
  const quantity = (values as { quantity?: string | number }).quantity ?? "";
  const quantityError = (errors as { quantity?: string | null }).quantity;

  useEffect(() => {
    if (isEdit) {
      setValues({ ...bomItem });
    } else {
      setValues({ ...bomItem, quantity: 0 });
    }
    // Populate once from the item that opened this popup.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = () => {
    if (isEdit) {
      confirmAction(values, index);
    } else {
      confirmAction(values);
    }
  };

  const unitLabel =
    bomItem.unit_of_measure?.label || bomItem.unit_of_measure_label || "";

  return (
    <div className="justify-between">
      <div>
        <div className="flex flex-wrap items-center justify-between sm:flex-nowrap">
          <div className="mt-2">
            <h3 className="text-lg font-medium leading-6 text-gray-900">
              {bomItem.name}
            </h3>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 py-2 sm:grid-cols-2">
          <Input
            label="Quantity to use"
            name="quantity"
            onChange={handleInputChange}
            value={quantity}
            labelOn={true}
            type="number"
            step="0.01"
            suffix={unitLabel || undefined}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-35-custom shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
            error={quantityError}
          />
        </div>

        <div className="my-auto flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={onSubmit}
            className="mt-3 inline-flex items-center justify-center rounded-md border border-transparent bg-main-purple px-4 py-35-custom text-sm font-medium text-white shadow-sm hover:bg-indigo-700"
          >
            OK
          </button>
          <button
            type="button"
            onClick={() =>
              setOpen({
                open: false,
                childComponent: null,
              })
            }
            className="mt-3 inline-flex items-center justify-center rounded-md border border-transparent bg-gray-600 px-4 py-35-custom text-sm font-medium text-white shadow-sm hover:bg-gray-700"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
